/** @type {Set<string>} */
const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com'
])

class FixedReel extends HTMLElement {
  /** @type {HTMLIFrameElement | null} */
  frame = null

  /** @type {HTMLVideoElement | null} */
  player = null

  /** @type {HTMLButtonElement | null} */
  closeButton = null

  /** @type {HTMLElement | null} */
  dialogHost = null

  /** @param {MouseEvent} event */
  handleCloseClick = (event) => {
    event.preventDefault()
    this.dialogHost?.close()
  }

  connectedCallback() {
    this.frame = this.querySelector('[data-fixed-reel-frame]')
    this.player = this.querySelector('.fixed-reel__player')
    this.closeButton = this.querySelector('[data-fixed-reel-close]')
    this.dialogHost = this.querySelector('dialog-element')
    this.handleOpen = () => this.startPlayback()
    this.handleClose = () => this.stopPlayback()

    this.addEventListener('dialog:open', this.handleOpen)
    this.addEventListener('dialog:close', this.handleClose)
    this.closeButton?.addEventListener('click', this.handleCloseClick)
  }

  disconnectedCallback() {
    this.removeEventListener('dialog:open', this.handleOpen)
    this.removeEventListener('dialog:close', this.handleClose)
    this.closeButton?.removeEventListener('click', this.handleCloseClick)
  }

  startPlayback() {
    if (this.player) {
      this.player.play().catch(() => null)
      return
    }
    this.loadVideo()
  }

  stopPlayback() {
    if (this.player) {
      this.player.pause()
      this.player.currentTime = 0
      return
    }
    this.unloadVideo()
  }

  loadVideo() {
    if (!this.frame || this.frame.hasAttribute('src')) return

    const embedUrl = this.getEmbedUrl()
    if (!embedUrl) return
    this.frame.src = embedUrl
  }

  unloadVideo() {
    if (!this.frame) return
    this.frame.removeAttribute('src')
  }

  /** @returns {string} */
  getEmbedUrl() {
    const source = this.dataset.videoSrc?.trim()
    if (!source) return ''

    try {
      const parsed = new URL(source)
      return this.buildEmbedUrl(parsed)
    } catch {
      return ''
    }
  }

  /** @param {URL} parsed */
  buildEmbedUrl(parsed) {
    const videoId =
      parsed.searchParams.get('v') ||
      parsed.pathname.split('/').filter(Boolean).pop()
    const isYoutubeHost =
      YOUTUBE_HOSTS.has(parsed.hostname) || parsed.hostname === 'youtu.be'

    if (!(videoId && isYoutubeHost)) return ''

    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&controls=0&rel=0&playsinline=1&modestbranding=1&disablekb=1&fs=0&iv_load_policy=3&cc_load_policy=0&enablejsapi=1`
  }
}

if (!customElements.get('fixed-reel')) {
  customElements.define('fixed-reel', FixedReel)
}
